// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SunbedPricesRouteImport } from './routes/sunbed-prices'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PhotoCreditsRouteImport } from './routes/photo-credits'
import { Route as PartnerRouteImport } from './routes/partner'
import { Route as HowWeVerifyRouteImport } from './routes/how-we-verify'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as ClubsRouteImport } from './routes/clubs'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as GuidesIndexRouteImport } from './routes/guides.index'
import { Route as LocaleIndexRouteImport } from './routes/$locale.index'
import { Route as RegionKeyRouteImport } from './routes/region.$key'
import { Route as ManageTokenRouteImport } from './routes/manage.$token'
import { Route as GuidesSlugRouteImport } from './routes/guides.$slug'
import { Route as ClubSlugRouteImport } from './routes/club.$slug'
import { Route as LocaleTermsRouteImport } from './routes/$locale.terms'
import { Route as LocalePrivacyRouteImport } from './routes/$locale.privacy'
import { Route as LocalePartnerRouteImport } from './routes/$locale.partner'
import { Route as LocaleFaqRouteImport } from './routes/$locale.faq'
import { Route as LocaleClubsRouteImport } from './routes/$locale.clubs'
import { Route as ThemeThemeIndexRouteImport } from './routes/theme.$theme.index'
import { Route as LocaleGuidesIndexRouteImport } from './routes/$locale.guides.index'
import { Route as ThemeThemeRegionRouteImport } from './routes/theme.$theme.$region'
import { Route as LocaleRegionKeyRouteImport } from './routes/$locale.region.$key'
import { Route as LocaleGuidesSlugRouteImport } from './routes/$locale.guides.$slug'
import { Route as LocaleClubSlugRouteImport } from './routes/$locale.club.$slug'
import { Route as LocaleThemeThemeIndexRouteImport } from './routes/$locale.theme.$theme.index'
import { Route as LocaleThemeThemeRegionRouteImport } from './routes/$locale.theme.$theme.$region'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SunbedPricesRoute = SunbedPricesRouteImport.update({
            id: '/sunbed-prices',path: '/sunbed-prices',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PhotoCreditsRoute = PhotoCreditsRouteImport.update({
            id: '/photo-credits',path: '/photo-credits',getParentRoute: () => rootRouteImport
          })
const PartnerRoute = PartnerRouteImport.update({
            id: '/partner',path: '/partner',getParentRoute: () => rootRouteImport
          })
const HowWeVerifyRoute = HowWeVerifyRouteImport.update({
            id: '/how-we-verify',path: '/how-we-verify',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const ClubsRoute = ClubsRouteImport.update({
            id: '/clubs',path: '/clubs',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const GuidesIndexRoute = GuidesIndexRouteImport.update({
            id: '/guides/',path: '/guides/',getParentRoute: () => rootRouteImport
          })
const LocaleIndexRoute = LocaleIndexRouteImport.update({
            id: '/$locale/',path: '/$locale/',getParentRoute: () => rootRouteImport
          })
const RegionKeyRoute = RegionKeyRouteImport.update({
            id: '/region/$key',path: '/region/$key',getParentRoute: () => rootRouteImport
          })
const ManageTokenRoute = ManageTokenRouteImport.update({
            id: '/manage/$token',path: '/manage/$token',getParentRoute: () => rootRouteImport
          })
const GuidesSlugRoute = GuidesSlugRouteImport.update({
            id: '/guides/$slug',path: '/guides/$slug',getParentRoute: () => rootRouteImport
          })
const ClubSlugRoute = ClubSlugRouteImport.update({
            id: '/club/$slug',path: '/club/$slug',getParentRoute: () => rootRouteImport
          })
const LocaleTermsRoute = LocaleTermsRouteImport.update({
            id: '/$locale/terms',path: '/$locale/terms',getParentRoute: () => rootRouteImport
          })
const LocalePrivacyRoute = LocalePrivacyRouteImport.update({
            id: '/$locale/privacy',path: '/$locale/privacy',getParentRoute: () => rootRouteImport
          })
const LocalePartnerRoute = LocalePartnerRouteImport.update({
            id: '/$locale/partner',path: '/$locale/partner',getParentRoute: () => rootRouteImport
          })
const LocaleFaqRoute = LocaleFaqRouteImport.update({
            id: '/$locale/faq',path: '/$locale/faq',getParentRoute: () => rootRouteImport
          })
const LocaleClubsRoute = LocaleClubsRouteImport.update({
            id: '/$locale/clubs',path: '/$locale/clubs',getParentRoute: () => rootRouteImport
          })
const ThemeThemeIndexRoute = ThemeThemeIndexRouteImport.update({
            id: '/theme/$theme/',path: '/theme/$theme/',getParentRoute: () => rootRouteImport
          })
const LocaleGuidesIndexRoute = LocaleGuidesIndexRouteImport.update({
            id: '/$locale/guides/',path: '/$locale/guides/',getParentRoute: () => rootRouteImport
          })
const ThemeThemeRegionRoute = ThemeThemeRegionRouteImport.update({
            id: '/theme/$theme/$region',path: '/theme/$theme/$region',getParentRoute: () => rootRouteImport
          })
const LocaleRegionKeyRoute = LocaleRegionKeyRouteImport.update({
            id: '/$locale/region/$key',path: '/$locale/region/$key',getParentRoute: () => rootRouteImport
          })
const LocaleGuidesSlugRoute = LocaleGuidesSlugRouteImport.update({
            id: '/$locale/guides/$slug',path: '/$locale/guides/$slug',getParentRoute: () => rootRouteImport
          })
const LocaleClubSlugRoute = LocaleClubSlugRouteImport.update({
            id: '/$locale/club/$slug',path: '/$locale/club/$slug',getParentRoute: () => rootRouteImport
          })
const LocaleThemeThemeIndexRoute = LocaleThemeThemeIndexRouteImport.update({
            id: '/$locale/theme/$theme/',path: '/$locale/theme/$theme/',getParentRoute: () => rootRouteImport
          })
const LocaleThemeThemeRegionRoute = LocaleThemeThemeRegionRouteImport.update({
            id: '/$locale/theme/$theme/$region',path: '/$locale/theme/$theme/$region',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRoute: AdminRoute,ClubsRoute: ClubsRoute,FaqRoute: FaqRoute,HowWeVerifyRoute: HowWeVerifyRoute,PartnerRoute: PartnerRoute,PhotoCreditsRoute: PhotoCreditsRoute,PrivacyRoute: PrivacyRoute,SunbedPricesRoute: SunbedPricesRoute,TermsRoute: TermsRoute,LocaleClubsRoute: LocaleClubsRoute,LocaleFaqRoute: LocaleFaqRoute,LocalePartnerRoute: LocalePartnerRoute,LocalePrivacyRoute: LocalePrivacyRoute,LocaleTermsRoute: LocaleTermsRoute,ClubSlugRoute: ClubSlugRoute,GuidesSlugRoute: GuidesSlugRoute,ManageTokenRoute: ManageTokenRoute,RegionKeyRoute: RegionKeyRoute,LocaleIndexRoute: LocaleIndexRoute,GuidesIndexRoute: GuidesIndexRoute,LocaleClubSlugRoute: LocaleClubSlugRoute,LocaleGuidesSlugRoute: LocaleGuidesSlugRoute,LocaleRegionKeyRoute: LocaleRegionKeyRoute,ThemeThemeRegionRoute: ThemeThemeRegionRoute,LocaleGuidesIndexRoute: LocaleGuidesIndexRoute,ThemeThemeIndexRoute: ThemeThemeIndexRoute,LocaleThemeThemeRegionRoute: LocaleThemeThemeRegionRoute,LocaleThemeThemeIndexRoute: LocaleThemeThemeIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)